/**
 * Типы дополнительных услуг в системе
 */
export enum AdditionalServiceType {
    TEMPLATE_CONFIGURATION = 'template_configuration',
    REALTY_CONFIGURATION = 'realty_configuration',
    AMO_CONFIGURATION = 'amo_configuration',
    BITRIX_CONFIGURATION = 'bitrix_configuration',
    LEGAL_CHECKS = 'legal_checks',
    AI_TEMPLATE_CONFIGURATION = 'ai_template_configuration'
}

/**
 * Возвращает список всех значений типов дополнительных услуг
 */
export function getAllAdditionalServiceTypes(): string[] {
    return Object.values(AdditionalServiceType)
}

/**
 * Проверяет, является ли тип дополнительной услугой
 */
export function isAdditionalService(serviceType: string): boolean {
    return getAllAdditionalServiceTypes().includes(serviceType)
}

